import { Router, NavigationStart, NavigationEnd }     from '@angular/router';
import { filter, pairwise } from 'rxjs/operators';

import { Component, OnInit, OnDestroy, NgModule, Input } from '@angular/core';
import { CacheService } from './../../../../services/sys/cache.service';
import { PageTitleService}      from './../../../../services/ui/page-title.service';
import { StringToStringMap } from './../../../interfaces/string-string-map.interface';
import { CmnUiService } from './../../../../services/ui/cmn-ui.service';

declare var $: any;

@Component({
    providers: [CmnUiService],
    selector: 'cmn-header',
    templateUrl: 'cmn-header.component.html',
    standalone: false
})

/**
 * This is the sortableHeader.ts component used outside of the application.
 */
export class CmnHeaderComponent implements OnInit {
    
    @Input()
    showProgMenu : boolean;

    headerFieldLabels: StringToStringMap<string> = {};
    showEnglish: boolean = true;
    showApplicationOptions: boolean = false;
    
	navTitles: StringToStringMap<string> = {};

    constructor(private router: Router,
		private cacheService: CacheService,
        private cmnUiService: CmnUiService,
        private pageTitleService: PageTitleService) {
    }

    ngOnInit() {
        this.setUpText();

        setTimeout(() => {
            this.cmnUiService.placeSvgCode('#logo');
        }, 0);
    };
    
    setUpText() {
		this.headerFieldLabels['skipLinks'] = this.cacheService.getLabelFromResource('COMMON:COMMON100008SkipLinks');

		this.navTitles = {};
        this.navTitles['home'] = this.cacheService.getLabelFromResource('COMMON:COMMON100010');
        this.navTitles['needHelp'] = this.cacheService.getLabelFromResource('COMMON:COMMON100023');
    }

    home() {
        alert('home clicked');
    }

    /**
     * Checks the ViewPortService to determine if the current display size matches desktop.
     * Also checks the headerService to ensure the menu isn't empty because we don't want to
     * add an empty NAV element to the DOM and confuse screen readers.
     */
    public canDisplayDesktopMenu():boolean {
     return true;
    }

    /**
     * Checks the ViewPortService to determine if the current display size matches mobile.
     * Also checks the headerService to ensure the menu isn't empty because we don't want to
     * add an empty NAV element to the DOM and confuse screen readers.
     */
    public canDisplayMobileMenu():boolean {
     return false;
    }

}
